<div class="profile-completion">
  <div class="profile-completion__badge">
    <ion-icon name="person-outline"></ion-icon>
  </div>

  <h3 class="profile-completion__title">
    {{ "MODALS.PROFILE_COMPLETION.TITLE" | translate }}
  </h3>

  <p class="profile-completion__message">
    {{ "MODALS.PROFILE_COMPLETION.MESSAGE" | translate }}
  </p>

  <form class="profile-completion__form" [formGroup]="form" (ngSubmit)="submit()">
    <div class="profile-completion__field">
      <label class="profile-completion__label" for="profile-first-name">
        {{ "MODALS.PROFILE_COMPLETION.FIRST_NAME" | translate }}
      </label>
      <input
        id="profile-first-name"
        class="profile-completion__input"
        type="text"
        formControlName="first_name"
        autocomplete="given-name"
      />
      <p
        *ngIf="showError('first_name', 'required') || showError('first_name', 'placeholderName')"
        class="profile-completion__field-error"
      >
        {{ "MODALS.PROFILE_COMPLETION.ERROR_FIRST_NAME" | translate }}
      </p>
    </div>

    <div class="profile-completion__field">
      <label class="profile-completion__label" for="profile-last-name">
        {{ "MODALS.PROFILE_COMPLETION.LAST_NAME" | translate }}
      </label>
      <input
        id="profile-last-name"
        class="profile-completion__input"
        type="text"
        formControlName="last_name"
        autocomplete="family-name"
      />
      <p
        *ngIf="showError('last_name', 'required') || showError('last_name', 'placeholderName')"
        class="profile-completion__field-error"
      >
        {{ "MODALS.PROFILE_COMPLETION.ERROR_LAST_NAME" | translate }}
      </p>
    </div>

    <div class="profile-completion__field">
      <label class="profile-completion__label" for="profile-email">
        {{ "MODALS.PROFILE_COMPLETION.EMAIL" | translate }}
      </label>
      <input
        id="profile-email"
        class="profile-completion__input"
        type="email"
        formControlName="email"
        autocomplete="email"
        inputmode="email"
        (input)="resetEmailError()"
      />
      <p *ngIf="showError('email', 'required')" class="profile-completion__field-error">
        {{ "MODALS.PROFILE_COMPLETION.ERROR_EMAIL_REQUIRED" | translate }}
      </p>
      <p *ngIf="showError('email', 'email')" class="profile-completion__field-error">
        {{ "MODALS.PROFILE_COMPLETION.ERROR_EMAIL_INVALID" | translate }}
      </p>
      <p *ngIf="emailError" class="profile-completion__field-error">
        {{ emailErrorMessage }}
      </p>
    </div>

    <p *ngIf="serverError" class="profile-completion__error">
      {{ serverError }}
    </p>

    <button class="profile-completion__cta" type="submit" [disabled]="loading">
      <app-spinner *ngIf="loading"></app-spinner>
      <span *ngIf="!loading">{{ "MODALS.PROFILE_COMPLETION.CTA" | translate }}</span>
    </button>
  </form>
</div>
